import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class GooglePayTokenPurchaseSample extends Component {
    getOrderId() {
        const { order_id, selectedProgLangId } = this.props;
        if(order_id === "none") {
            switch(selectedProgLangId) {
                case _DOTNET:
                    return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
                case _JAVA:
                    return `"Test"+createDate.getTime()`;
                case _PHP:
                    return `'ord-'.date("dmy-G:i:s")`;
                default:
                    return "";
            }
        }
        else
            return `"${order_id}"`;
    }

    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    render() {
        const { selectedProgLangId } = this.props;

        switch(selectedProgLangId) {
            case _DOTNET:
                return (
                    <pre className="sampleCode">
{`namespace Moneris
{
using System;
using System.Collections.Generic;
using System.Text;
using Moneris;

public class TestCanadaGooglePayTokenPurchase
{
public static void Main(string[] args)
{
string order_id = "Test" + DateTime.Now.ToString("yyyyMMddhhmmss");
String store_id = "intuit_sped";
String api_token = "spedguy";
string amount = "1.00";
string crypt_type = "2";
string cust_id = "nqa-cust_id";
string network = "MASTERCARD";
string data_key = "ot-Gf7ImkVrnHNyLHcTu2SRsutK1";
string threeds_server_trans_id = "de1b97ee-c610-4877-b53f-c1c5ecd99bf0";
string threeds_version = "2.2";
string cavv = "kAABApFSYyd4l2eQQFJjAAAAAAA=";
string dynamic_descriptor = "nqa-dd";
string processing_country_code = "CA";

GooglePayTokenPurchase googlePayTokenPurchase = new GooglePayTokenPurchase();
googlePayTokenPurchase.SetOrderId(order_id);
googlePayTokenPurchase.SetCustId(cust_id);
googlePayTokenPurchase.SetAmount(amount);
googlePayTokenPurchase.SetCryptType(crypt_type);
googlePayTokenPurchase.SetNetwork(network);
googlePayTokenPurchase.SetDataKey(data_key);
googlePayTokenPurchase.SetThreeDSServerTransId(threeds_server_trans_id);
googlePayTokenPurchase.SetThreeDSVersion(threeds_version);
googlePayTokenPurchase.SetCavv(cavv);
googlePayTokenPurchase.SetDynamicDescriptor(dynamic_descriptor);

HttpsPostRequest mpgReq = new HttpsPostRequest();
mpgReq.SetProcCountryCode(processing_country_code);
mpgReq.SetTestMode(true); //false or comment out this line for production transactions
mpgReq.SetStoreId(store_id);
mpgReq.SetApiToken(api_token);
mpgReq.SetTransaction(googlePayTokenPurchase);
mpgReq.Send();

try
{
Receipt receipt = mpgReq.GetReceipt();
Console.WriteLine("CardType = " + receipt.GetCardType());
Console.WriteLine("TransAmount = " + receipt.GetTransAmount());
Console.WriteLine("TxnNumber = " + receipt.GetTxnNumber());
Console.WriteLine("ReceiptId = " + receipt.GetReceiptId());
Console.WriteLine("TransType = " + receipt.GetTransType());
Console.WriteLine("ReferenceNum = " + receipt.GetReferenceNum());
Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
Console.WriteLine("ISO = " + receipt.GetISO());
Console.WriteLine("BankTotals = " + receipt.GetBankTotals());
Console.WriteLine("Message = " + receipt.GetMessage());
Console.WriteLine("AuthCode = " + receipt.GetAuthCode());
Console.WriteLine("Complete = " + receipt.GetComplete());
Console.WriteLine("TransDate = " + receipt.GetTransDate());
Console.WriteLine("TransTime = " + receipt.GetTransTime());
Console.WriteLine("Ticket = " + receipt.GetTicket());
Console.WriteLine("TimedOut = " + receipt.GetTimedOut());
Console.WriteLine("IsVisaDebit = " + receipt.GetIsVisaDebit());
Console.WriteLine("PaymentType = " + receipt.GetPaymentType());
Console.WriteLine("HostId = " + receipt.GetHostId());
Console.WriteLine("IssuerId = " + receipt.GetIssuerId());
Console.WriteLine("SourcePanLast4 = " + receipt.GetSourcePanLast4());
Console.WriteLine("ThreeDSVersion = " + receipt.GetThreeDSVersion());
Console.WriteLine("DataKey = " + receipt.GetDataKey());
Console.WriteLine("CavvResultCode = " + receipt.GetCavvResultCode());
Console.WriteLine("Par = " + receipt.GetPar());
Console.WriteLine("GooglepayPaymentMethod = " + receipt.GetGooglepayPaymentMethod());
Console.ReadLine();
}
catch (Exception e)
{
Console.WriteLine(e);
}
}
}
}
`}
                </pre>)

        case _JAVA:
            return (
                <pre className="sampleCode">
{`package Canada;

import JavaAPI.GooglePayTokenPurchase;
import JavaAPI.HttpsPostRequest;
import JavaAPI.Receipt;

public class TestCanadaGooglePayTokenPurchase
{
public static void main(String[] args)
{
java.util.Date createDate = new java.util.Date();
String order_id = "Test"+createDate.getTime();
String store_id = "intuit_sped";
String api_token = "spedguy";
String amount = "1.00";
String cust_id = "nqa-cust_id";
String network = "MASTERCARD";
String data_key = "ot-5N7NHu23o7w82xL8KLOXV2vC1";
String crypt_type = "2";
String threeds_server_trans_id = "de1b97ee-c610-4877-b53f-c1c5ecd99bf0";
String threeds_version = "2.2";
String cavv = "kAABApFSYyd4l2eQQFJjAAAAAAA=";
String dynamic_descriptor = "nqa-dd";
String processing_country_code = "CA";
boolean status_check = false;

GooglePayTokenPurchase googlePayTokenPurchase = new GooglePayTokenPurchase();
googlePayTokenPurchase.setOrderId(order_id);
googlePayTokenPurchase.setCustId(cust_id);
googlePayTokenPurchase.setAmount(amount);
googlePayTokenPurchase.setNetwork(network);
googlePayTokenPurchase.setDataKey(data_key);
googlePayTokenPurchase.setCryptType(crypt_type);
googlePayTokenPurchase.setThreeDSServerTransId(threeds_server_trans_id);
googlePayTokenPurchase.setDSTransId(ds_trans_id);
googlePayTokenPurchase.setThreeDSVersion(threeds_version);
googlePayTokenPurchase.setCavv(cavv);
googlePayTokenPurchase.setDynamicDescriptor(dynamic_descriptor);

HttpsPostRequest mpgReq = new HttpsPostRequest();
mpgReq.setProcCountryCode(processing_country_code);
mpgReq.setTestMode(true); //false or comment out this line for production transactions
mpgReq.setStoreId(store_id);
mpgReq.setApiToken(api_token);
mpgReq.setTransaction(googlePayTokenPurchase);
mpgReq.setStatusCheck(status_check);
//Optional - Proxy
mpgReq.setProxy(false); //true to use proxy
mpgReq.setProxyHost("proxyURL");
mpgReq.setProxyPort("proxyPort");
mpgReq.setProxyUser("proxyUser"); //optional - domainName\User
mpgReq.setProxyPassword("proxyPassword"); //optional
mpgReq.send();

try
{
Receipt receipt = mpgReq.getReceipt();
System.out.println("CardType = " + receipt.getCardType());
System.out.println("TransAmount = " + receipt.getTransAmount());
System.out.println("TxnNumber = " + receipt.getTxnNumber());
System.out.println("ReceiptId = " + receipt.getReceiptId());
System.out.println("TransType = " + receipt.getTransType());
System.out.println("ReferenceNum = " + receipt.getReferenceNum());
System.out.println("ResponseCode = " + receipt.getResponseCode());
System.out.println("ISO = " + receipt.getISO());
System.out.println("BankTotals = " + receipt.getBankTotals());
System.out.println("Message = " + receipt.getMessage());
System.out.println("AuthCode = " + receipt.getAuthCode());
System.out.println("Complete = " + receipt.getComplete());
System.out.println("TransDate = " + receipt.getTransDate());
System.out.println("TransTime = " + receipt.getTransTime());
System.out.println("Ticket = " + receipt.getTicket());
System.out.println("TimedOut = " + receipt.getTimedOut());
System.out.println("IsVisaDebit = " + receipt.getIsVisaDebit());
System.out.println("Payment Type = " + receipt.getPaymentType());
System.out.println("HostId = " + receipt.getHostId());
System.out.println("IssuerId = " + receipt.getIssuerId());
System.out.println("SourcePanLast4 = " + receipt.getSourcePanLast4());
System.out.println("ThreeDSVersion = " + receipt.getThreeDSVersion());
System.out.println("CavvResultCode = " + receipt.getCavvResultCode());
System.out.println("DataKey = " + receipt.getDataKey());
System.out.println("Par = " + receipt.getPar());
System.out.println("GooglepayPaymentMethod = " + receipt.getGooglepayPaymentMethod());
}
catch (Exception e)
{
e.printStackTrace();
}
}
}
`}
                </pre>
            )

        case _PHP:
            return (
                <pre className="sampleCode">
{`<?php
require "../../mpgClasses.php";
/**************************** Request Variables *******************************/
$store_id='intuit_sped';
$api_token='spedguy';
/************************* Transactional Variables ****************************/
$order_id='ord-'.date("dmy-G:i:s");
$cust_id='nqa cust id';
$amount='1.00';
$crypt_type='2';
$network = "MASTERCARD";
$data_key = "ot-eJ7J1FxbUrLkUow8Kko7Djie1";
$threeds_server_trans_id = "de1b97ee-c610-4877-b53f-c1c5ecd99bf0";
$threeds_version = "2.2";
$cavv = "kAABApFSYyd4l2eQQFJjAAAAAAA=";
$dynamic_descriptor = "nqa-dd";
/*********************** Transactional Associative Array **********************/
$googlePayTokenPurchase = new googlePayTokenPurchase();
$googlePayTokenPurchase->setOrderId($order_id);
$googlePayTokenPurchase->setCustId($cust_id);
$googlePayTokenPurchase->setAmount($amount);
$googlePayTokenPurchase->setCryptType($crypt_type);
$googlePayTokenPurchase->setNetwork($network);
$googlePayTokenPurchase->setDataKey($data_key);
$googlePayTokenPurchase->setThreeDSServerTransId($threeds_server_trans_id);
$googlePayTokenPurchase->setThreeDSVersion($threeds_version);
$googlePayTokenPurchase->setCavv($cavv);
$googlePayTokenPurchase->setDynamicDescriptor($dynamic_descriptor);
/**************************** Transaction Object *****************************/
$mpgTxn = new mpgTransaction($googlePayTokenPurchase);
/****************************** Request Object *******************************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions
/***************************** HTTPS Post Object *****************************/
/* Status Check Example
$mpgHttpPost =new mpgHttpsPostStatus($store_id,$api_token,$status_check,$mpgRequest);
*/
$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);
/******************************* Response ************************************/
$mpgResponse=$mpgHttpPost->getMpgResponse();
print("\\nCardType = " . $mpgResponse->getCardType());
print("\\nTransAmount = " . $mpgResponse->getTransAmount());
print("\\nTxnNumber = " . $mpgResponse->getTxnNumber());
print("\\nReceiptId = " . $mpgResponse->getReceiptId());
print("\\nTransType = " . $mpgResponse->getTransType());
print("\\nReferenceNum = " . $mpgResponse->getReferenceNum());
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nISO = " . $mpgResponse->getISO());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nIsVisaDebit = " . $mpgResponse->getIsVisaDebit());
print("\\nAuthCode = " . $mpgResponse->getAuthCode());
print("\\nComplete = " . $mpgResponse->getComplete());
print("\\nTransDate = " . $mpgResponse->getTransDate());
print("\\nTransTime = " . $mpgResponse->getTransTime());
print("\\nTicket = " . $mpgResponse->getTicket());
print("\\nTimedOut = " . $mpgResponse->getTimedOut());
print("\\nStatusCode = " . $mpgResponse->getStatusCode());
print("\\nStatusMessage = " . $mpgResponse->getStatusMessage());
print("\\nHostId = " . $mpgResponse->getHostId());
print("\\nIssuerId = " . $mpgResponse->getIssuerId());
print("\\nPayment Type = " . $mpgResponse->getPaymentType());
print("\\nSourcePanLast4 = " . $mpgResponse->getSourcePanLast4());
print("\\nDataKey = " . $mpgResponse->getDataKey());
print("\\nCavvResultCode = " . $mpgResponse->getCavvResultCode());
print("\\nPar = " . $mpgResponse->getPar());
print("\\nThreeDSVersion = " . $mpgResponse->getThreeDSVersion());
print("\\nGooglepayPaymentMethod = " . $mpgResponse->getGooglepayPaymentMethod());
?>`}
                </pre>
            )
        default:
            return null
        }
    }
}

const mapStateToProps = state => {
  const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci, onEditId } = state.threeDSTwo.main.config;
  const { selection } = state.common.progLangList;
  return { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci, selectedProgLangId: selection, onEditId };
}

export default connect(mapStateToProps, {})(GooglePayTokenPurchaseSample)
